import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../shared/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
      const currentUser = this.authenticationService.gettoken();
      if (currentUser) {
        // authorised so return true
        return true;
    } else {
 // not logged in so redirect to login page with the return url
 this.router.navigate(['/']);
 
 //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }, skipLocationChange: true});
 return false;
    }

  }
  
}
